// extracted by mini-css-extract-plugin
export default {"form":"AddPaymentMethod_form__o47H3"};